import React, { useReducer, useEffect, useState } from 'react';

import {
  Editor,
  EditorState,
  ContentState
} from 'draft-js';

import { validate } from '../../../utils/validators';
import './Input.css';

import 'draft-js/dist/Draft.css';

const inputReducer = (state, action) => {
  console.log(action);
  switch (action.type) {
    case 'CHANGE':
      return {
        ...state,
        value: action.val,
        isValid: validate(action.val, action.validators)
      };
    case 'TOUCH':
      return {
        ...state,
        isTouched: true
      };
    default:
      return state;
  }
};
const Draft = (props) => {
  const {
    id,
    onInput,
    label,
    validators,
    initialValue,
    initialValid,
  } = props;

  const [inputState, dispatch] = useReducer(inputReducer, {
    value: initialValue || '',
    isValid: initialValid || false,
    isTouched: initialValid || false
  });
  const [estado, setEstado] = useState(initialValue ? EditorState.createWithContent(ContentState.createFromText(initialValue)) : EditorState.createEmpty());
  const {
    value,
    isValid
  } = inputState;

  useEffect(() => {
    onInput(id, value, isValid);
  }, [id, value, isValid, onInput]);

  const changeHandler = (event) => {
    setEstado(event);
    dispatch({ type: 'CHANGE', val: estado.getCurrentContent().getPlainText(), validators });
  };

  return (
    <div className={`draft ${!isValid ? 'is-invalid' : ''}`}>
      <label htmlFor={id}>{label}</label>
      <Editor
        id={id}
        editorState={estado}
        onChange={changeHandler}
      />
    </div>
  );
};
export default Draft;
